import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  textBase: {
    color: '#424140',
    fontSize: '16px',
    lineHeight: '22px',
    marginTop: 8,
    marginBottom: 12,
  },
  textSmall: {
    color: '#424140',
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: 0,
  },
  cardHeader: {
    paddingBottom: '0 !important',
  },
  cardBody: {
    paddingTop: 0,
    paddingBottom: 8,
  },
  cardsWrapper: {
    '&>:last-child > div': {
      borderBottom: 'none',
    },
  },
  skeletonWrapper: {
    '& > .MuiGrid-item': {
      padding: '16px 0',
    },
  },
  isLayout4: {
    paddingBottom: 8,
    '& > .MuiGrid-item': {
      flexGrow: 0,
      maxWidth: '50%',
      flexBasis: '50%',
      '&:nth-child(-n+2) > div': {
        borderTop: 'none',
      },
      '&:nth-child(even) > div': {
        borderLeft: '1px solid #DBD9D6',
        paddingLeft: 16,
      },
      '&:nth-child(odd) > div': {
        paddingRight: 16,
      },
    },
    '& > .MuiGrid-item > div': {
      borderTop: '1px solid #DBD9D6',
      borderBottom: 'none',
    },
  },
}))
